module.exports = __webpack_public_path__ + "assets/769f0314fb737c384f0a9f0987e92621.mp3";